import { HTMLFromRichText, PrismicImageProps, PrismicLink, TextFromRichText } from './PrismicTypes';

export const GENERIC_TEXT_IMAGE_LAYOUT = 'PrismicGenericTemplateDataBodyTextImageLayout1';

export interface GenericTextImageLayoutPrimary {
  heading: TextFromRichText;
  hide_image_mobile: boolean;
  image: PrismicImageProps;
  primary_button_link: PrismicLink;
  primary_button_text: TextFromRichText;
  secondary_button_link: PrismicLink;
  secondary_button_text: TextFromRichText;
  variant: 'white' | 'grey' | 'mint';
}

export interface GenericTextImageLayoutField {
  step_title: TextFromRichText;
  step_description: HTMLFromRichText;
}

export interface GenericTextImageLayoutContent {
  __typename: typeof GENERIC_TEXT_IMAGE_LAYOUT;
  items: GenericTextImageLayoutField[];
  primary: GenericTextImageLayoutPrimary;
}
